import React from 'react';
import { Container, SectionHeading } from './ui';
import { cn } from '@/lib/utils';

export default function PageHero({ eyebrow, title, subtitle, align = 'center', children, tone = 'light', image }) {
  const dark = tone === 'dark';
  return (
    <section
      className={cn(
        'relative overflow-hidden border-b px-5 py-16 sm:px-8 sm:py-20',
        dark ? 'border-white/10 bg-brand-ink' : 'border-slate-200 bg-slate-50 dark:border-white/10 dark:bg-white/[0.02]'
      )}
    >
      {image && (
        <img src={image} alt="" aria-hidden className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-20" />
      )}
      {dark && <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-brand/25 blur-[120px]" />}
      <div className="bp-grid-bg pointer-events-none absolute inset-0 opacity-40 dark:opacity-25" />
      <Container className="relative">
        <div className={cn(dark && '[&_h2]:text-white [&_p]:text-slate-300')}>
          <SectionHeading eyebrow={eyebrow} title={title} subtitle={subtitle} align={align} />
        </div>
        {children && (
          <div className={cn('mt-8 flex flex-col gap-3 sm:flex-row', align === 'center' && 'justify-center')}>{children}</div>
        )}
      </Container>
    </section>
  );
}
